import "./loginStyle.css"

import React, { Component } from "react";

import LoginForm from "./LoginForm.js";
import LoginOAuth from "./LoginOAuth.js";

import bild from "./bild.webp";



export default class LoginPage extends Component{

    static defaultProps = {
        someState: false,
    };
    constructor(props) {
        super(props);

        this.state = {
            sessionActive: false,
        };
    }




    renderLoginPage()
        {
            return (
                <div className="loginPageContainer">
                    <div className="loginPageTextBox">
                        <p>Välkommen till hempejl! Här kan du annonsera din bostad till försäljning – helt gratis.</p>
                        <img src={bild} style={{width:'80%'}}/>
                    </div>
                    <div className="formContainer">
                        <LoginForm />
                        <LoginOAuth />
                    </div>

                </div>
            );
        }

        render(){
            return(this.renderLoginPage());
        }
};
